/*
 * Created by alex@hackerbay.com on 29.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

import * as React from "react";
import {translate} from "react-i18next";

import {Button, Col, Container, Input, Row} from "reactstrap";

class DownloadCalendarFileLink extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        return <a
            download={true}
            target={"_self"}
            href={`${process.env.REACT_APP_FUNCTION_BASE_URL}calendar?urlIdent=${this.props.urlIdent}`}>
            {this.props.text}
        </a>
    }
}

export default (DownloadCalendarFileLink);